import { OptimizelyFeatureFlags } from 'constants/optimizely'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

function getIsLoyaltyEsimEnabled(state: App.State): boolean {
  return getIsLoyaltyEnabled(state)
    && !!state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.loyaltyEsimBenefit]
}

export default getIsLoyaltyEsimEnabled
